import React from 'react';
import styles from './Preloader.module.css';

const Preloader = () => {
  return (
    <div className={styles.preloaderWrapper}>
      <div className={styles.loader3d}>
          <img src="/images/favicon-16x16.png" alt="Loading..." className={styles.favicon3d} />
      </div>
    </div>
  );
};

export default Preloader;
